



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IComment, IUser } from '@/lib/interfaces';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['users']),
})
export default class CommentRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  @Prop() private comment!: IComment;
}
